import styled, { css } from "styled-components";

export const inputStyles = css`
  width: 100%;
  height: 42px;
  padding: 0 11px;
  border: 2px solid #c5c9d1;
  border-radius: 4px;
  overflow: hidden;
  background-color: white;
  font-family: "Circular", sans-serif;
  font-size: 15px;
  font-weight: normal;
  transition: color 0.1s;
  color: #576474;
  outline: none;
  &::placeholder {
    color: #c4c8d0;
  }
`;

export const Container = styled.div`
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  margin-bottom: 18px;
  font-size: 15px;
  font-weight: normal;
  line-height: 24px;
  input {
    ${inputStyles}
    margin-top: 10px;
  }
`;

export const Error = styled.span`
  position: absolute;
  right: 0;
  font-size: 12px;
  color: #fd5154;
`;

export const ModalCloser = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  width: 16px;
  height: 16px;
  z-index: 10;
  cursor: pointer;
`;

export const RecaptchaWrapper = styled.div`
  padding: 10px 0 30px;
  min-height: 74px;
  box-sizing: content-box;
`;

export const ConfirmationIconLayout = styled.div`
  width: 48px;
  height: 48px;
  margin: 0 auto 20px;
`;

export const ConfirmationMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px 0px;
  text-align: center;
  svg {
    fill: ${({ status, theme }) => {
      switch (status) {
        case "success":
          return theme.colors.cma[500];
        case "error":
          return theme.colors.accent.red;
        default:
          return theme.colors.gray[700];
      }
    }};
  }
  p {
    margin: 0;
    text-align: center;
  }
`;
